import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowUpRight } from 'lucide-react';
import { nav, company } from '../mock';
import { ElementMark } from './Navbar';

const Footer = () => {
  return (
    <footer className="bg-neutral-950 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-3 gap-14">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <ElementMark light size="sm" />
              <div className="flex flex-col justify-center gap-1">
                <div className="font-display font-bold tracking-[0.18em] text-lg leading-none">WHITEMOON</div>
                <div className="eyebrow opacity-50 text-[0.6rem] leading-none">{company.tagline}</div>
              </div>
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed max-w-xs">
              A US-based magnesium exploration and development company restoring domestic supply security for a critical mineral.
            </p>
          </div>

          <div>
            <div className="eyebrow text-amber-500 mb-6">Navigate</div>
            <ul className="grid grid-cols-2 grid-rows-4 grid-flow-col gap-x-8 gap-y-3">
              {nav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-neutral-300 hover:text-white transition-colors duration-300 text-sm inline-flex items-center gap-1 group"
                  >
                    {item.label}
                    <ArrowUpRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="eyebrow text-amber-500 mb-6">Contact</div>
            <ul className="space-y-4 text-sm text-neutral-300">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-neutral-500" />
                <a href={`mailto:${company.email}`} className="hover:text-white transition-colors">{company.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-neutral-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-neutral-500 text-xs">{company.copyright}</p>
          <div className="flex items-center gap-3">
            <p className="eyebrow text-neutral-600 text-[0.6rem]">Mg · 12 · 24.305</p>
            <span
              data-testid="footer-signature"
              title="100"
              aria-label="one hundred"
              className="text-sm opacity-40 hover:opacity-100 hover:scale-110 transition-all duration-300 cursor-default select-none"
            >
              💯
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
